import React from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { FormGroup } from 'react-bootstrap';
import { isBoolean } from 'lodash';

export function MultiSelectDropdown(props) {
  const { placeHolder, rowIndex, colIndex, onChange, onMenuToggle, options, CustomAddEditAccess, gridY, isProductArchived } = props;

  return (
    <FormGroup className="mb-0 flex-fill position-relative select-min-height mr-0">
      <div>
        <MultiSelect
          options={options}
          className={`product-custom-multiselect common-new-multiselect w-100 ${gridY > 30 && 'menu-dropdown-up'}`}
          value={props?.value || []}
          disabled={(isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false) || isProductArchived}
          labelledBy={placeHolder}
          overrideStrings={{
            selectSomeItems: placeHolder,
          }}
          onChange={(e) => onChange(e, rowIndex, colIndex)}
          onMenuToggle={onMenuToggle}
        />
      </div>
    </FormGroup>
  );
}
export default MultiSelectDropdown;
